<template>
    <div
        :class="{
            'content-register--list-item':true,
        }"
        :data-index="index"
        :draggable="!disabled && useDrag"
    >
        <div v-if="useDrag && !disabled" class="list-item__drag-icon">
            <HamburgerSvg/>
        </div>
        <div class="list-item__thumbnail">
            <div class="thumbnail-wrapper">
                <img ref="thumbnail" :src="mediaContent.snapshot_url" class="content--info_image" draggable="false">
                <div v-if="!waitMediaContent" class="thumbnail-duration">
                    {{ fileDuration }}
                </div>
            </div>
        </div>
        <div class="list__media-contents">
            <div class="media-contents__name">
                <span>{{ mediaContent.title }}</span>
            </div>
            <div class="media-contents__info">
                <template v-if="isTranscodingFail">
                    <span class="content-info_tr-fail">{{ $t('words.transcoding_fail') }}</span>
                </template>
                <template v-else-if="!isTranscodingFail && !isMediaInformationEmpty">
                    <div
                        v-if="mediaContent.is_passthru"
                        class="content-info_media-block content-info_media-type"
                    >
                        <span>PASSTHROUGH</span>
                    </div>
                    <div
                        v-tooltip="$t('words.audio_codec')"
                        class="content-info_media-block"
                    >
                        <span>{{ audioInformation.audio_codec }}</span>
                    </div>
                    <div
                        v-tooltip="$t('words.sample_rate')"
                        class="content-info_media-block"
                    >
                        <span>
                            {{ audioInformation.audio_samplerate }}
                        </span>
                    </div>
                    <div
                        v-tooltip="$t('words.frame_rate')"
                        class="content-info_media-block"
                    >
                        <span>{{ videoInformation.video_framerate }}</span>
                    </div>
                    <div
                        v-tooltip="$t('words.resolution')"
                        class="content-info_media-block"
                    >
                        <span>
                            {{ videoInformation.video_screen_size }}
                        </span>
                    </div>
                </template>
            </div>
        </div>
        <div v-if="!disabled" class="list-item--delete">
            <button class="btn--icon btn--icon--xs"
                    @click="doRemoveFile">
                <i class="icon icon-close icon-close-sm"></i>
            </button>
        </div>
        <div v-if="useDrag && isDragging"
             :class="{
                 'content-register--list-drag-dummy':true,
                 'dragging-item': dragItemIndex === index,
                 'hover-item': hoverItemIndex === index,
             }"
             :data-index="index"
        />
    </div>
</template>

<script>
import TranscodingProgressCircle
    from '@/components/cms/common/Content/ContentBodyTable/MediaContentsStatus/TranscodingProgressCircle';
import StatusPlay from '@/components/cms/common/Content/ContentBodyTable/MediaContentsStatus/StatusPlay';
import _ from 'lodash';
import ContentListItemMixin from '@/components/mixin/ContentListItemMixin';
import HamburgerSvg from '@/components/svg/HamburgerSvg';

export default {
    name: 'ContentRegisterListItem',
    mixins: [
        ContentListItemMixin,
    ],
    components: {
        HamburgerSvg,
        StatusPlay,
        TranscodingProgressCircle,
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        useDrag: {
            type: Boolean,
            default: false,
        },
        waitMediaContent: {
            type: Boolean,
            default: false,
        },
        isDragging: {
            type: Boolean,
            default: false,
        },
        index: {
            type: Number,
            default: -1,
        },
        dragItemIndex: {
            type: Number,
            default: -1,
        },
        hoverItemIndex: {
            type: Number,
            default: -1,
        },
    },

    computed: {
        isMediaInformationEmpty() {
            return _.isEmpty(this.mediaContent.transcoding_file.media_information);
        },
        fileDuration() {
            return this.mediaContent.transcoding_file ? this.mediaContent.transcoding_file.media_information.file.duration : '';
        },
    },

    data() {
        return {
            thumbnailDataUrl: '',
        };
    },

    async mounted() {
        this.thumbnailDataUrl = await this.convertImgSrcToBase64();
    },

    async updated() {
        // 반응이 밀려 src 소스가 늦게 업데이트 되는경우가 있어 beforeUpdated => updated 로 라이프 사이클 변경
        this.thumbnailDataUrl = await this.convertImgSrcToBase64();
    },

    methods: {
        doRemoveFile() {
            this.$emit('doRemoveFile');
        },
        convertImgSrcToBase64() {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.crossOrigin = 'Anonymous';
                img.onload = () => {
                    let canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    canvas.height = img.height;
                    canvas.width = img.width;
                    ctx.drawImage(img, 0, 0);
                    const dataURL = canvas.toDataURL();
                    canvas = null;
                    resolve(dataURL);
                };
                img.src = this.$refs.thumbnail.src;
            });
        },
    },
};
</script>
